<template>
  <v-card v-if="ticket">
    <v-card-title>
      <v-avatar size=48>
        <v-icon color="primary" large>share</v-icon>
      </v-avatar>
      <span class="subheading text-uppercase pl-2">
        Sharing
      </span>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap class="font-weight-bold ml-2 mr-2">
        <v-flex xs9 class="pt-2">Email</v-flex>
        <v-flex xs3 class="text-xs-right"><v-btn color="success" small icon flat outline @click="addShare()"><v-icon>add</v-icon></v-btn></v-flex>
      </v-layout>
      <hr>

      <v-layout v-for="(share, idx) in shares" :key="idx" row class="mt-3">
        <v-flex class="xs9 text-no-wrap text-truncate subheading" v-if="share.id">
          <v-icon color="primary">email</v-icon>
          {{share.attributes.email}}
        </v-flex>
        <v-flex class="xs9" v-else>
          <v-text-field
            prepend-icon="email"
            class="ma-0 pa-0"
            v-model="share.attributes.email"
            placeholder="email@example.com"
            clearable
            :rules="[rules.email]"
          ></v-text-field>
        </v-flex>

        <v-flex class="xs9 text-no-wrap text-truncate text-xs-right" v-if="share.id">
          <v-btn color="warning" @click="deleteShare(share)">Remove</v-btn>
        </v-flex>
        <v-flex class="xs9 text-no-wrap text-truncate text-xs-right" v-else>
          <v-btn color="primary" @click="createShare(idx, share)" :disabled="!(rules.email(share.attributes.email) === true)">Invite</v-btn>
        </v-flex>
      </v-layout>

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="done()">Done</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import shareService from '@/services/share'

  export default {
    name: 'ticket-share',

    props: ['ticket'],

    data () {
      return {
        shares: [],
        rules: {
          email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'Not a valid email address'
        }
      }
    },

    mounted () {
      this.loadShares()
    },

    computed: {
    },

    methods: {
      addShare () {
        this.shares.push({
          attributes: {
            email: ''
          }
        })
      },

      loadShares () {
        shareService.ticketIndex(
          (data) => {
            this.shares = data.sort((a, b) => { return a.attributes.email.toLowerCase().localeCompare(b.attributes.email.toLowerCase()) })
          },
          (err) => {
            console.log(err)
          },
          this.ticket.id
        )
      },

      createShare (idx, share) {
        shareService.ticketCreate(
          (data) => {
            this.shares[idx] = Object.assign({}, data)
            // trigger a refresh
            this.shares = Object.assign([], this.shares)
            EventBus.$emit('share-created', data)
          },
          (err) => {
            console.log(err)
            // TODO, check if it failed becuase it already exists
          },
          this.ticket.id,
          share.attributes
        )
      },

      deleteShare (share) {
        shareService.ticketDelete(
          (data) => {
            // nothing to do here
            this.shares = this.shares.filter(item => item.id !== share.id)
            EventBus.$emit('share-deleted', data)
          },
          (err) => {
            console.log(err)
          },
          this.ticket.id,
          share.id
        )
      },

      done () {
        // remove all the uninvited people
        this.shares = this.shares.filter(item => item.id)
        EventBus.$emit('share-completed')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-expansion-panel-setting {
    background-color: #0155a8 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ticket/_share.vue